export const large = (props) => (props.large ? { height: '120px', width: '120px' } : null)

export const small = (props) => (props.small ? { height: '60px', width: '60px' } : null)

export const xsmall = (props) => (props.xsmall ? { height: '40px', width: '40px' } : null)

export const xxsmall = (props) => (props.xxsmall ? { height: '24px', width: '24px' } : null)
